import React from "react";
import CommonContainer from "../../../layouts/layoutnew/CommonContainer";
import "./patients.scss";
function Patients({ route }: any) {
  return (
    <>
      <CommonContainer
        SUBNAV={route.SUBNAV}
        TITLE={route.TITLE}
        MAINTITLE={route.MAINTITLE}
      />
      <div className="patients">
        <header>
          <h2>All Patients</h2>
        </header>
        <div className="search_bar">
          <div className="left">
            <div className="form_search">
              <input type="search" />
            </div>
            <div className="form_date">
              <input type="date" />
            </div>
          </div>
          <button></button>
        </div>
      </div>
    </>
  );
}

export default Patients;
